import { render, staticRenderFns } from "./StationDetail.vue?vue&type=template&id=110c8e7e&scoped=true"
import script from "./StationDetail.vue?vue&type=script&lang=js"
export * from "./StationDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "110c8e7e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/cmgames.septemberdev.nl/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('110c8e7e')) {
      api.createRecord('110c8e7e', component.options)
    } else {
      api.reload('110c8e7e', component.options)
    }
    module.hot.accept("./StationDetail.vue?vue&type=template&id=110c8e7e&scoped=true", function () {
      api.rerender('110c8e7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/teacher/vue/StationDetail.vue"
export default component.exports